import { Drawer, Button, message, Form, Input, Alert } from "antd";
import { useDispatch } from "react-redux";
import api from "@/api";

import dataJson from "@/../public/data.json";

interface Props {
  type: string | undefined;
  id: string | undefined;
  visible: boolean;
  close: () => void;
}
const ApplyDown = (props: Props) => {
  const { type, id, visible, close } = props;
  const { req_err, release, confirmText, cancelText, remark_text, please_enter, app_detail } = dataJson;
  const [form] = Form.useForm();

  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[type!];

  const dispatch = useDispatch();

  const onDetermine = async () => {
    try {
      const values = await form.validateFields();
      try {
        const req = { ...values, id: id };
        const res: any = await api[typeItem.auditDownApi](req);

        if (res?.code == 200) {
          window.message.success(release.audit_down_success);
          onClose();
          dispatch({
            type: "setIsReload",
            payload: true,
          });
        } else {
          window.message.error(res.msg);
        }
      } catch (errorInfo: any) {
        window.message.error(errorInfo?.response?.data?.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.log(errorInfo);
    }
  };

  const onClose = () => {
    form.resetFields();
    close();
  };

  const DrawerFooter = (
    <div style={{ textAlign: "right" }}>
      <Button type="primary" ghost onClick={onClose}>
        {cancelText}
      </Button>
      <Button type="primary" onClick={onDetermine} style={{ marginLeft: "24px" }}>
        {confirmText}
      </Button>
    </div>
  );

  return (
    <Drawer title={release.audit_down} closable={false} zIndex={2001} open={visible} width={600} footer={DrawerFooter}>
      <Alert message={release.audit_down_tip + typeItem.typeName} type="warning" style={{ marginBottom: "12px" }} />
      <Form form={form} layout="vertical">
        <Form.Item
          label={release.reason_label}
          name="reason"
          rules={[{ required: true, message: release.reason_required }]}
        >
          <Input.TextArea placeholder={release.reason_required} showCount maxLength={300} />
        </Form.Item>

        <Form.Item label={remark_text} name="remark">
          <Input.TextArea placeholder={please_enter + remark_text} showCount maxLength={300} />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ApplyDown;
